import { IntlShape } from 'react-intl';
import { withViewModel } from '../../../../infrastructure/components/with-view-model';
import { ConnectionTemplateFormPresentation } from './connection-template-form.presentation';
import { ConnectionTemplatesFormVM } from './connection-template-form.viewmodel';

export type ConnectionsTemplateFormProps = {
    accountId: number;
    intl: IntlShape;
    blueprintId: string;
    apiCallSuccessCallback: () => void;
    deleteCompletionCallback?: () => void;
};

export const ConnectionsTemplatesForm = withViewModel(ConnectionTemplateFormPresentation, async ({
    accountId,
    blueprintId,
    intl,
    apiCallSuccessCallback,
    deleteCompletionCallback,
}: ConnectionsTemplateFormProps) => {
    const vm = new ConnectionTemplatesFormVM(
        accountId,
        blueprintId,
        intl,
        apiCallSuccessCallback,
        deleteCompletionCallback,
    );
    await vm.initFormVM();

    return vm;
});
